module.exports = __webpack_public_path__ + "toBride1-we-r-g.202cfc5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-we-r-g.jpg
// module id = i7jP
// module chunks = 0